import { useState, useEffect } from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import "../styles/user-profile.scss";
import Avatar from '@mui/material/Avatar';
import Modal from 'react-modal';
import { Button, Select, MenuItem  } from '@mui/material';
import { createPayment, getTariffs } from './api';
import { setNotificationMessage, setShowNotification } from '../store';

export const UserData = (props) => {

    Modal.setAppElement('#root');

    const {data} = props;
    const [isOpen, setIsOpen] = useState(false);
    const [tariffs, setTariffs] = useState([]);
    const [selectedTariffId, setSelectedTariffId] = useState('');

    const handleChange = (event) => {
        setSelectedTariffId(event.target.value);
    };

    const statuses = ["Новый", "На модерации", "Прошел модерацию", "Ожидается оплата",
        "Активный", "Отклонен", "Подписка истекла", "Ожидается первая оплата", "Заблокирован"];

    let userStatus = statuses[data.status];
    if (data.status === 4){
        userStatus = "Подписка действительна до " + new Date(data.subscriptionEndData).toLocaleDateString();
    }
    else if (data.status === 6){
        userStatus = "Подписка истекла " + new Date(data.subscriptionEndData).toLocaleDateString();
    }

    useEffect(() => {
        getTariffs().then(data => {setTariffs(data)});
    }, []);

    const clickPay = async () => {
        if(selectedTariffId != ''){
            let url = '';
            url = await createPayment({ tariffId: selectedTariffId, userId: data.id });
            window.open(url, '_blank');
            setIsOpen(false);
        }
        else{
            setNotificationMessage("Выберите тариф");
            setShowNotification(true);
        }
    }

    return (
        <div>
            <div className="user-profile-head">
                <Avatar sx={{ width: 120, height: 120, mr: 2, display: "inline-flex" }}>{data.fullName?.substring(0, 1)}</Avatar>             
                <h3>{data.fullName}</h3>
                <p>{userStatus}</p>
                {(data.status === 4 || data.status === 6 || data.status === 2 || data.status === 3 || data.status === 7) && 
                    <Button variant="contained" onClick={() => setIsOpen(true)}>Оплатить подписку</Button>
                }
            </div>
            <div className="contact-info">
                <h4 className="contact-info-head">Контактные данные</h4>
                <div className="contact-info-lines">
                    <div className="contact-info-line">
                        <PhoneIcon />
                        <p className="contact">{data.phoneNumber}</p>
                    </div>
                    <div className="contact-info-line">
                        <MailOutlineIcon />
                        <p className="contact">{data.email}</p>
                    </div>
                </div>
            </div>
            <Modal
                className="modal-content-custom"
                overlayClassName="modal-overlay-custom"
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}>
                <div className='modal'>
                    <h2>Оплата подписки</h2>
                    <Select
                        className='select-tariffs'
                        value={selectedTariffId}
                        onChange={handleChange}
                        displayEmpty>
                        <MenuItem value="">
                            <em>Выберите тариф</em>
                        </MenuItem>
                        {tariffs.map((tariff) => (
                            <MenuItem key={tariff.id} value={tariff.id}>
                            {tariff.name} — {tariff.price} руб.
                            </MenuItem>
                        ))}
                    </Select>                   
                    <div className='group-button'>
                        <Button className='button-close' variant="contained" onClick={() => setIsOpen(false)}>Закрыть</Button>
                        <Button variant="contained" onClick={() => clickPay()}>Оплатить</Button>
                    </div>
                </div>
            </Modal>
        </div>
    )

}